import { render, staticRenderFns } from "./TeacherForm.vue?vue&type=template&id=3453fe53&"
import script from "./TeacherForm.vue?vue&type=script&lang=js&"
export * from "./TeacherForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports